export default [
    {
        title: 'Logisticas',
        fontIcon: 'truck-loading',
        resource: 'Logistica',
        action: 'ver-logistica',
        children: [
            {
                title: 'Dashboard',
                icon: 'LayoutIcon',
                resource: 'Logistica',
                action: 'ver-logistica-dashboard',
            },
            {
                title: 'Configuracion',
                icon: 'SettingsIcon',
                resource: 'Logistica',
                action: 'ver-logistica-configuracion',
            },
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Logistica',
                action: 'ver-logistica-mantenimiento',
                children: [
                    {
                        route: 'logistica-mantenimiento-zonas',
                        title: 'Zonas',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-zonas',
                    },
                    {
                        route: 'logistica-mantenimiento-camaroneras',
                        title: 'Camaroneras',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-camaroneras',
                    },
                    {
                        route: 'logistica-mantenimiento-sectores',
                        title: 'Sectores',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-sectores',
                    },
                    {
                        route: 'logistica-mantenimiento-piscinas',
                        title: 'Piscinas',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-piscinas',
                    },
                    {
                        route: 'logistica-mantenimiento-rutas',
                        title: 'Rutas',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-rutas',
                    },
                    {
                        route: 'logistica-mantenimiento-aprob-zona',
                        title: 'Aprobación de zonas',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-aprob-zona',
                    },
                    {
                        route: 'logistica-mantenimiento-chofer',
                        title: 'Chofer',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-chofer',
                    },
                    {
                        route: 'logistica-mantenimiento-vehiculo',
                        title: 'Vehiculo',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-vehiculo',
                    },
                    {
                        route: 'logistica-mantenimiento-infraccion',
                        title: 'Infraccion',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-infraccion',
                    },
                    {
                        route: 'logistica-mantenimiento-lista-negra',
                        title: 'Lista Negra',
                        resource: 'Logistica',
                        action: 'ver-logistica-mantenimiento-lista-negra',
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Logistica',
                action: 'ver-logistica-transacciones',
                children: [
                    {
                        route: 'logistica-transacciones-distribucion-pesca',
                        title: 'Distribucion Pesca',
                        resource: 'Logistica',
                        action: 'ver-logistica-transacciones-distribucion-pesca',
                    },
                    {
                        route: 'logistica-transaccion-cambio-camaronera-raleo',
                        title: 'Cambio de camaronera',
                        resource: 'Logistica',
                        action: 'ver-logistica-transaccion-cambio-camaronera-raleo',
                    },
                    {
                        route: 'logistica-transacciones-cambio-destino',
                        title: 'Actualizar Ruta',
                        resource: 'Logistica',
                        action: 'ver-logistica-transacciones-cambio-destino',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Logistica',
                action: 'ver-logistica-informes',
                children: [
                    {
                        route: 'logistica-reportes',
                        title: 'Monitoreo de pesca',
                        resource: 'Logistica',
                        action: 'ver-logistica-reportes',
                    },
                    {
                        route: 'logistica-informes-distribucion-pesca',
                        title: 'Distribucion Pesca',
                        resource: 'Logistica',
                        action: 'ver-logistica-informes-distribucion-pesca',
                    },

                    {
                        route: 'logistica-informes-estado-bines',
                        title: 'Estado Bines',
                        resource: 'Logistica',
                        action: 'ver-logistica-informes-estado-bines',
                    },
                ],
            },
        ],
    },
]
